import React from "react";
import Card from "common/components/Card/Card.jsx";
import CardHeader from "common/components/Card/CardHeader.jsx";
import CardIcon from "common/components/Card/CardIcon.jsx";
import CardBody from "common/components/Card/CardBody.jsx";
import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";

// @material-ui/core components
import MobileFriendlyIcon from "@material-ui/icons/MobileFriendly";

import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import withStyles from "@material-ui/core/styles/withStyles";
import googleplay from "assets/img/google-play-badge.png";
import applestore from "assets/img/apple-store.svg";

const importedStyle = dashboardStyle;

const styles = {
  ...regularFormsStyle,
  cardCategory: importedStyle.cardCategory,
  cardTitle: importedStyle.cardTitle,
  cardIconTitle: {
    ...importedStyle.cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
  },
  legendContainer: {
    textAlign: "center",
  },
  myText: {
    textAlign: "left",
    marginTop: "40px",
    marginBottom: "40px",
    marginLeft: "20px",
  },
  googleplay: {
    width: "200px",
  },
  applestore: {
    width: "160px",
  },
};

const MyAccountApp = (props) => {
  const { classes } = props;

  return (
    <Card>
      <CardHeader color="primary" icon>
        <CardIcon color="primary">
          <MobileFriendlyIcon />
        </CardIcon>
        <h4 className={classes.cardIconTitle}>MyAccount App</h4>
      </CardHeader>
      <CardBody>
        <GridContainer>
          <GridItem xs={12} className={classes.legendContainer}>
            <div className={classes.myText}>
              <h4>
                Did you know we have a mobile App with extended features?
                Download it now:
              </h4>
              <a
                target="_blank"
                href="https://apps.apple.com/ca/app/mcsnet-my-account/id1541377100"
              >
                <img className={classes.applestore} src={applestore} />
              </a>
              <a
                target="_blank"
                href="https://play.google.com/store/apps/details?id=ca.mcsnet.myaccount.twa&hl=en_CA&gl=US"
              >
                <img className={classes.googleplay} src={googleplay} />
              </a>
            </div>
          </GridItem>
        </GridContainer>
      </CardBody>
    </Card>
  );
};

export default withStyles(styles)(MyAccountApp);
